import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import { useField, FieldProps } from 'formik';
import RadioBase from './RadioBase';

interface OptionType {
  value: string;
  label: string;
  description?: string;
}

interface Props extends FieldProps {
  options: OptionType[];
}

const FormikRadioGroup = ({ field, options, ...props }: Props) => {
  const fieldName = field.name;
  const [, meta] = useField(fieldName);

  const { error, touched } = meta;
  const isError = typeof error === 'string' && touched;

  return (
    <>
      <RadioGroup {...field} {...props} name={fieldName}>
        {options.map((option: OptionType) => (
          <React.Fragment key={option.value}>
            <RadioBase
              value={option.value || ''}
              checked={field.value === option.value}
              onChange={field.onChange}
              label={option.label}
              id={fieldName}
              isError={isError}
            />
            {!!option.description && (
              <div style={{ marginLeft: '2rem', fontSize: 'small' }}>
                {option.description}
              </div>
            )}
          </React.Fragment>
        ))}
      </RadioGroup>
    </>
  );
};

export default FormikRadioGroup;
